import type { UsWebSdkBootstrapRuntimeConfig } from '@/types/webSdkBootstrap';
import { buildRuntimeConfigFromEnvironment } from '@/config/runtimeConfigFromEnvironment';

export const RUNTIME_CONFIG_ATTRIBUTE = 'data-web-sdk-runtime-config';

function readRuntimeConfigFromDom(): UsWebSdkBootstrapRuntimeConfig | null {
    if (typeof document === 'undefined') {
        return null;
    }

    const serializedRuntimeConfig = document.documentElement.getAttribute(RUNTIME_CONFIG_ATTRIBUTE)?.trim();

    if (!serializedRuntimeConfig) {
        return null;
    }

    try {
        return JSON.parse(serializedRuntimeConfig) as UsWebSdkBootstrapRuntimeConfig;
    } catch (error) {
        console.error('[web-sdk] Failed to parse preloaded runtime config.', error);
        return null;
    }
}

export function getPreloadedRuntimeConfig(): UsWebSdkBootstrapRuntimeConfig | null {
    if (typeof window === 'undefined') {
        return null;
    }

    const browserWindow = window as BrowserWindow;

    if (browserWindow.__WEB_SDK_RUNTIME_CONFIG__) {
        return browserWindow.__WEB_SDK_RUNTIME_CONFIG__;
    }

    const runtimeConfigFromDom = readRuntimeConfigFromDom();

    if (runtimeConfigFromDom) {
        browserWindow.__WEB_SDK_RUNTIME_CONFIG__ = runtimeConfigFromDom;
    }

    return runtimeConfigFromDom;
}

export function getRuntimeConfig(): UsWebSdkBootstrapRuntimeConfig {
    if (typeof window === 'undefined') {
        return buildRuntimeConfigFromEnvironment(process.env);
    }

    const runtimeConfig = getPreloadedRuntimeConfig();

    if (!runtimeConfig) {
        throw new Error('[runtime-config] Missing serialized runtime configuration.');
    }

    return runtimeConfig;
}

export function getCareBaseUrl(): string {
    return getRuntimeConfig().care.baseUrl.trim();
}

export function getTrialActivationBaseUrl(): string {
    return getRuntimeConfig().trial.activationBaseUrl.trim();
}
